import { render } from "./BulkImport.vue?vue&type=template&id=56606ede&scoped=true"
import script from "./BulkImport.vue?vue&type=script&lang=js"
export * from "./BulkImport.vue?vue&type=script&lang=js"

import "./BulkImport.vue?vue&type=style&index=0&id=56606ede&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56606ede"]])

export default __exports__